import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'fb-annotazioni-del-sistema',
    templateUrl: './annotazioni-del-sistema.component.html',
    styleUrls: ['./annotazioni-del-sistema.component.scss'],
})
export class AnnotazioniDelSistemaComponent implements OnInit {
    @Input()
    annotazioniDelSistema: string;

    get annotazioniDelSistemaFormatted() {
        return this.annotazioniDelSistema?.replace('\r\n', '\n').replace('\r', '\n').trim().split('\n');
    }

    constructor() {}

    ngOnInit(): void {}
}
